export default __webpack_public_path__ + "static/media/spring.94f201ce.png";